// extracted by mini-css-extract-plugin
export var explainable = "_gw-0";